import {Component} from '@angular/core';

@Component({
  selector: 'gatewee-skeleton',
  templateUrl: './gatewee-skeleton.component.html',
  styleUrls: ['./gatewee-skeleton.component.css'],
  standalone: true,
})
export class GateweeSkeletonComponent {}
